/* eslint-disable eqeqeq */
// @ts-nocheck
import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CFormCheck,
  CFormInput,
  CFormSelect,
  CModal,
  CModalContent,
  CModalHeader,
  CNav,
  CNavItem,
  CNavLink,
  CSpinner,
  CTabContent,
  CTabPane,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import PlusIcon from "../../../components/icons/PlusIcon";
import RichTextEditor from "../../../components/ui/RichTextEditor";
import { useAuth } from "../../../hooks/useAuth";
import { useCookie } from "../../../hooks/useCookie";
import { useToast } from "../../../hooks/useToast";
import { general } from "../../../locales/general";
import apiService from "../../../service/apiService";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { ReactSortable } from "react-sortablejs";
import * as yup from "yup";
import FileUploader from "../../../components/ui/FileUploader";
import DotIcon from "../../../components/icons/DotIcon";
import UndoIcon from "../../../components/icons/UndoIcon";
import InfiniteScrollSelect from "../../../components/ui/InfiniteScrollSelect";
import TimeSelectInput from "../../../components/inputs/TimeSelectInput";
import { DAYS_OF_THE_WEEK, ROLES } from "../../../config/constants";
import { FormMode, OFFER_TYPES } from "../../../helpers/enums";
import {
  isPositive,
  toDateInputValue,
  verifyFileList,
} from "../../../helpers/general";
import { useSelectedPlace } from "../../../hooks/place/useSelectedPlace";
import { Field, FormSection } from "../../../components/ui/FormUi";
import { cardStyle } from "../../Places/PlacesTable";

const cleanOpeningHoursData = (originalData: any) => {
  const cleanedData = {
    exceptions: originalData?.exceptions ?? [],
    sunday: {},
    saturday: {},
    friday: {},
    thursday: {},
    wednesday: {},
    tuesday: {},
    monday: {},
  };

  // Transform days
  Object.keys(originalData).forEach((day) => {
    if (day === "exceptions") return;

    const originalDay = originalData[day];
    const cleanedDay = {};

    if (originalDay.status === "custom") {
      cleanedDay.ranges = originalDay.ranges.filter(
        (range) => range.to !== "" && range.from !== "",
      );
    } else if (originalDay.status === "openAllDay") {
      cleanedDay.openAllDay = true;
    } else {
      cleanedDay.closed = true;
    }

    cleanedData[day] = cleanedDay;
  });

  // delete cleanedData.exceptions;

  return cleanedData;
};

const getDayHoursType = (dayHours) => {
  if (dayHours.closed) {
    return "closed";
  } else if (dayHours.openAllDay) {
    return "openAllDay";
  } else {
    return "custom";
  }
};

const transformToFormValue = (value) => {
  if (value.closed) {
    return { status: "closed" };
  } else if (value.openAllDay) {
    return { status: "openAllDay" };
  } else {
    return {
      status: "custom",
      ranges: value.ranges ?? [],
    };
  }
};

const formattedExceptionDates = (exceptionDates) => {
  return exceptionDates.map((exception) => {
    return {
      ...exception,
      date: toDateInputValue(exception.date),
    };
  });
};

const exceptionDates = yup.array().of(
  yup.object({
    name: yup.string(),
    date: yup.date(),
    repeating: yup.string(),
  }),
);

function DayDisplayValue({ dayHours }) {
  if (dayHours.status === "closed") {
    return <div>Non disponible</div>;
  } else if (dayHours.status === "openAllDay") {
    return <div>Disponible</div>;
  } else if (dayHours.status === "custom") {
    return (
      <div>
        {dayHours.ranges?.map((range, index) => (
          <div key={index}>
            {range.from} - {range.to}
          </div>
        ))}
      </div>
    );
  } else {
    return null;
  }
}

const dayHours = yup.object({
  status: yup.string().default("closed"),
  ranges: yup.array().when("status", {
    is: "custom",
    then: () =>
      yup
        .array()
        .notRequired()
        .of(
          yup.object().shape({
            from: yup.string(),
            to: yup.string(),
          }),
        ),
  }),
});

const openingHoursSchema = yup.object({
  monday: dayHours,
  tuesday: dayHours,
  wednesday: dayHours,
  thursday: dayHours,
  friday: dayHours,
  saturday: dayHours,
  sunday: dayHours,
  exceptions: exceptionDates,
});
// !
function DayTimeInput({
  day,
  addOpeningHours,
  openingHours,
  dayEn,
  copyTo,
  formControl,
  formErrors,
  formSetValues,
  formGetValues,
  formWatchValues,
  formRegister,
}: DayTimeInputProps) {
  const { append: appendRange, remove: removeRange } = useFieldArray({
    control: formControl,
    name: `${dayEn}.ranges`,
  });

  const dayHours = formWatchValues(dayEn);
  const isCustomHours = dayHours.status === "custom";

  return (
    <CAccordionItem itemKey={dayEn}>
      <CAccordionHeader>
        <div className="w-full d-flex justify-content-between pe-2">
          <div>{day}</div>
          <div>
            <DayDisplayValue dayHours={dayHours} />
          </div>
        </div>
      </CAccordionHeader>
      <CAccordionBody>
        <div className="position-relative openingHour-type-wrapper">
          <div className="d-lg-flex align-items-center justify-content-between gap-4">
            <div className="d-lg-flex align-items-center gap-4">
              <CFormCheck
                type="radio"
                name={`${dayEn}-1-openingHr`}
                id={`${dayEn}-1-openingHr`}
                label="Non disponible"
                value="closed"
                {...formRegister(`${dayEn}.status`)}
              />
              <CFormCheck
                type="radio"
                name={`${dayEn}-2-openingHr`}
                id={`${dayEn}-2-openingHr`}
                label="Disponible"
                value="openAllDay"
                {...formRegister(`${dayEn}.status`)}
              />
              <CFormCheck
                type="radio"
                name={`${dayEn}-3-openingHr`}
                id={`${dayEn}-3-openingHr`}
                label="Personnalisé"
                value="custom"
                {...formRegister(`${dayEn}.status`)}
              />
            </div>
            <div>
              <CDropdown direction="center">
                <CDropdownToggle
                  className="outline-none border-0 rounded-sm bg-transparent d-flex align-items-center gap-2"
                  // color="primary"
                >
                  <DotIcon fill="black" width="18" />
                </CDropdownToggle>
                <CDropdownMenu>
                  <CDropdownItem
                    type="button"
                    onClick={() => {
                      copyTo("workDays", formGetValues(dayEn));
                    }}
                  >
                    Copier vers les jours ouvrés
                  </CDropdownItem>
                  <CDropdownItem
                    type="button"
                    onClick={() => {
                      copyTo("weekends", formGetValues(dayEn));
                    }}
                  >
                    Copier vers les week-ends
                  </CDropdownItem>
                  <CDropdownItem
                    type="button"
                    onClick={() => {
                      copyTo("all", formGetValues(dayEn));
                    }}
                  >
                    Copier vers tous
                  </CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            </div>
          </div>
          {isCustomHours && (
            <div>
              {dayHours.ranges.map((range, index) => (
                <div
                  key={range.id ?? index}
                  className="d-flex justify-content-between gap-3 mt-2"
                >
                  <div className="w-50">
                    <Controller
                      name={`${dayEn}.ranges.${index}.from`}
                      control={formControl}
                      render={({ field }) => (
                        <TimeSelectInput
                          label="Heure d'ouverture"
                          selectedTime={field.value}
                          onChange={(val) => field.onChange(val)}
                        />
                      )}
                    />
                  </div>
                  <div className="w-50 d-flex flex-column align-items-end">
                    <Controller
                      name={`${dayEn}.ranges.${index}.to`}
                      control={formControl}
                      render={({ field }) => (
                        <TimeSelectInput
                          label="Heure de clôture"
                          selectedTime={field.value}
                          onChange={(val) => field.onChange(val)}
                        />
                      )}
                    />
                  </div>
                  <div
                    className="d-flex align-items-end justify-content-end"
                    style={{ width: "45px" }}
                  >
                    {index > 0 && (
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => removeRange(index)}
                        style={{
                          width: "41px",
                          height: "41px",
                        }}
                      >
                        <DeleteIcon width="18" height="18" fill="#ffffff" />
                      </button>
                    )}
                  </div>
                </div>
              ))}
              <div className="mt-2 d-flex align-center justify-content-center">
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={() => appendRange({ from: "", to: "" })}
                >
                  <PlusIcon width="18" height="18" fill="#ffffff" />
                </button>
              </div>
            </div>
          )}
        </div>
      </CAccordionBody>
    </CAccordionItem>
  );
}

interface ModalProps {
  initialValues: any;
  visible: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
}

const WORK_DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday"];
const WEEKENDS = ["saturday", "sunday"];

export function OpeningHoursModal({
  initialValues,
  visible,
  onClose,
  onSubmit,
}: ModalProps) {
  const [activeKey, setActiveKey] = useState(1);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control: formControl,
    setValue: setFormValue,
    getValues: getFormValue,
    watch: watchFormValue,
    reset: resetForm,
  } = useForm({
    resolver: yupResolver(openingHoursSchema),
    defaultValues: {
      monday: {
        status: "closed",
        ranges: [{ from: "", to: "" }],
      },
      tuesday: {
        status: "closed",
        ranges: [{ from: "", to: "" }],
      },
      wednesday: {
        status: "closed",
        ranges: [{ from: "", to: "" }],
      },
      thursday: {
        status: "closed",
        ranges: [{ from: "", to: "" }],
      },
      friday: {
        status: "closed",
        ranges: [{ from: "", to: "" }],
      },
      saturday: {
        status: "closed",
        ranges: [{ from: "", to: "" }],
      },
      sunday: {
        status: "closed",
        ranges: [{ from: "", to: "" }],
      },
    },
  });

  const {
    fields: exceptionFields,
    append: appendException,
    remove: removeException,
    update: updateException,
  } = useFieldArray({
    control: formControl,
    name: "exceptions",
  });

  useEffect(() => {
    if (initialValues) {
      const formFields = Object.keys(openingHoursSchema.fields);
      Object.entries(initialValues).forEach((entry) => {
        const [day, value] = entry;
        if (formFields.indexOf(day) !== -1) {
          if (day === "exceptions") {
            setFormValue("exceptions", formattedExceptionDates(value));
          } else {
            const dayHoursType = getDayHoursType(value);
            if (dayHoursType === "custom") {
              setFormValue(day, transformToFormValue(value));
              setFormValue(`${day}.ranges`, value.ranges);
            } else {
              setFormValue(day, transformToFormValue(value));
            }
          }
        }
      });
    }
  }, [resetForm, initialValues, setFormValue]);

  const onSubmitHandler = async (data: any) => {
    const cleanedData = cleanOpeningHoursData(data);
    onSubmit(cleanedData);
  };

  const copyTo = (type: "workDays" | "weekends" | "all", value: any) => {
    if (type === "workDays") {
      WORK_DAYS.forEach((day) => {
        setFormValue(day, value);
      });
    } else if (type === "weekends") {
      WEEKENDS.forEach((day) => {
        setFormValue(day, value);
      });
    } else {
      // all
      [...WORK_DAYS, ...WEEKENDS].forEach((day) => {
        setFormValue(day, value);
      });

      // Object.keys(openingHoursSchema.fields).forEach(day => {
      //   setFormValue(day, value);
      // });
    }
  };

  return (
    <CModal
      visible={visible ? true : false}
      onClose={() => {
        onClose();
        setActiveKey(1);
      }}
      size="lg"
      backdrop="static"
    >
      <CModalHeader>
        <h5 className="fs-5">Configurer la disponibilité de l'offre</h5>
      </CModalHeader>
      <CModalContent className=" border-0 px-3 py-2">
        <form onSubmit={handleSubmit(onSubmitHandler)}>
          <CNav variant="tabs" role="tablist">
            <CNavItem role="presentation">
              <CNavLink
                active={activeKey === 1}
                component="button"
                type="button"
                role="tab"
                aria-controls="home-tab-pane"
                aria-selected={activeKey === 1}
                onClick={() => setActiveKey(1)}
              >
                Horaires de disponibilité
              </CNavLink>
            </CNavItem>
            <CNavItem role="presentation">
              <CNavLink
                active={activeKey === 2}
                component="button"
                type="button"
                role="tab"
                aria-controls="profile-tab-pane"
                aria-selected={activeKey === 2}
                onClick={() => setActiveKey(2)}
              >
                Configurer les jours fériés
              </CNavLink>
            </CNavItem>
          </CNav>
          <CTabContent>
            <CTabPane
              role="tabpanel"
              aria-labelledby="home-tab-pane"
              visible={activeKey === 1}
              className="pt-4"
            >
              <div className="row">
                <CAccordion alwaysOpen>
                  {DAYS_OF_THE_WEEK.map((day) => (
                    <div key={day.en} className="col-12">
                      <DayTimeInput
                        day={day.fr}
                        dayEn={day.en}
                        copyTo={copyTo}
                        formControl={formControl}
                        formErrors={errors}
                        formSetValues={setFormValue}
                        formGetValues={getFormValue}
                        formWatchValues={watchFormValue}
                        formRegister={register}
                      />
                    </div>
                  ))}
                </CAccordion>
              </div>
            </CTabPane>
            <CTabPane
              role="tabpanel"
              aria-labelledby="profile-tab-pane"
              visible={activeKey === 2}
            >
              {exceptionFields.map((exception, index) => (
                <ExceptionDate
                  key={exception.id}
                  index={index}
                  exception={exception}
                  removeException={() => removeException(index)}
                  updateException={updateException}
                  formControl={formControl}
                  formErrors={errors}
                  formSetValues={setFormValue}
                  formGetValues={getFormValue}
                  formWatchValues={watchFormValue}
                  formRegister={register}
                />
              ))}
              <div className="d-flex justify-content-center mt-4">
                <button
                  type="button"
                  className="btn btn-primary btn-sm text-white"
                  onClick={() =>
                    appendException({ name: "", date: "", repeating: "" })
                  }
                >
                  Ajouter une date
                </button>
              </div>
            </CTabPane>
          </CTabContent>
          <button
            type="submit"
            className="mt-4 btn btn-danger shadow-primary w-100 p-2 d-flex align-items-center justify-content-center text-white"
          >
            Enregistrer
          </button>
        </form>
      </CModalContent>
    </CModal>
  );
}

function ExceptionDate({
  exception,
  index,
  removeException,
  updateException,
  formControl,
  formErrors,
  formSetValues,
  formGetValues,
  formWatchValues,
  formRegister,
}) {
  return (
    <div className="d-flex justify-content-between border-bottom py-3">
      <div className="px-2" style={{ flex: 1 }}>
        <label htmlFor="name">Nom</label>
        <CFormInput
          name={`exceptions.${index}.name`}
          id={`exceptions.${index}.name`}
          {...formRegister(`exceptions.${index}.name`)}
        />
      </div>
      <div className="px-2" style={{ flex: 1 }}>
        <label htmlFor="name">Date</label>
        <CFormInput
          type="date"
          name={`exceptions.${index}.date`}
          {...formRegister(`exceptions.${index}.date`)}
        />
      </div>
      <div className="px-2" style={{ flex: 1 }}>
        <label htmlFor="name">Répétition annuelle</label>
        <CFormSelect
          className="mt-0"
          name={`exceptions.${index}.repeating`}
          {...formRegister(`exceptions.${index}.repeating`)}
        >
          <option selected value="">
            Choisissez une option
          </option>
          <option value="true">Oui</option>
          <option value="false">Non</option>
        </CFormSelect>
      </div>
      <div
        className="d-flex align-items-end justify-content-end"
        style={{ width: "45px" }}
      >
        <button
          type="button"
          className="btn btn-danger btn-sm"
          onClick={() => removeException()}
          style={{
            width: "41px",
            height: "41px",
          }}
        >
          <DeleteIcon width="18" height="18" fill="#ffffff" />
        </button>
      </div>
    </div>
  );
}

export default function NewSpecialOffer({ mode = FormMode.CREATE }) {
  const [formLoading, setFormLoading] = useState(false);
  const [showOpeningHours, setShowOpeningHours] = useState(false);
  const [description, setDescription] = useState("");
  const [offerAvailability, setOfferAvailability] = useState(null);
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const navigate = useNavigate();
  const params = useParams();
  const { isAdmin, user, isMultiPlaceAdmin } = useAuth();
  const [images, setImages] = useState({
    carousel: "",
    main: "",
  });
  const { selectedPlaceId } = useSelectedPlace(user, isAdmin);

  const isUserMultiPlaceAdmin =
    user?.role?.label?.toLowerCase() === ROLES.PLACE_ADMIN.toLowerCase() &&
    isMultiPlaceAdmin;

  const schema = yup.object({
    type: yup.string().nullable(),
    title: yup.string().required("Ce champ est obligatoire"),
    offerProvider: yup.string().nullable(),
    text: yup.string().nullable(),
    reductionPercent: yup
      .number()
      .positive()
      .nullable(true)
      .typeError()
      .transform((_, val) => (val ? Number(val) : null)),
    partnerCommission: yup
      .number()
      .min(0)
      .max(100)
      .nullable(true)
      .typeError()
      .transform((_, val) =>
        val === "" || val === null || val === undefined ? 0 : Number(val),
      ),
    price: yup
      .number()
      .positive()
      .nullable(true)
      .typeError()
      .transform((_, val) => (val ? Number(val) : null)),
    priceInEuro: yup
      .number()
      .positive()
      .nullable(true)
      .typeError()
      .transform((_, val) => (val ? Number(val) : null)),
    nightPrice: yup
      .number()
      .positive()
      .nullable(true)
      .typeError()
      .transform((_, val) => (val ? Number(val) : null)),
    nightPriceInEuro: yup
      .number()
      .positive()
      .nullable(true)
      .typeError()
      .transform((_, val) => (val ? Number(val) : null)),
    numberOfPersons: yup
      .number()
      .nullable(true)
      .typeError()
      .transform((_, val) => (val ? Number(val) : null)),
    date: yup
      .date()
      .nullable(true)
      .typeError()
      .transform((_, val) => (val ? new Date(val) : null)),
    duration: yup
      .number()
      .nullable(true)
      .typeError()
      .transform((_, val) => (val ? Number(val) : null)),
    picture: yup.mixed().nullable(),
    from: yup.string().nullable(),
    to: yup.string().nullable(),
    nightPriceHoursRange: yup
      .object({
        from: yup.string().nullable(),
        to: yup.string().nullable(),
      })
      .nullable(),
    weekDays: yup.array().nullable(),
    carouselImage: yup.mixed().required("Ce champ est obligatoire"),
    // paymentMethod: yup.string().required("Ce champ est obligatoire"),
    paymentMethodsInPlace: yup.boolean().nullable(),
    paymentMethodsCreditCard: yup.boolean().nullable(),
    paymentMethodsWafacash: yup.boolean().nullable(),
    paymentMethodsStripe: yup.boolean().nullable(),
    paymentMethodsBalance: yup.boolean().nullable(),
    minNumberOfPersons: yup.number().default(1),
    stepOfNumberOfPersons: yup.number().default(1),
    authConfirmBookings: yup.string().required("Ce champ est obligatoire"),
    isVisible: yup.string().required("Ce champ est obligatoire"),
    taxiActive: yup
      .string()
      .default("false")
      .required("Ce champ est obligatoire"),
    points: yup.number().default(0).optional(),

    latitude: yup.number().when("taxiActive", {
      is: (v) => v === "true" || v === true,
      then: () =>
        yup
          .number()
          .required("Ce champ est obligatoire")
          .typeError("Ce champ est obligatoire"),
      otherwise: () =>
        yup
          .number()
          .nullable()
          .optional()
          .typeError("Ce champ est obligatoire")
          .transform((_, val) => {
            const result = val == Number(val) ? Number(val) : null;
            return result;
          }),
    }),
    longitude: yup.number().when("taxiActive", {
      is: (v) => v === "true" || v === true,
      then: () =>
        yup
          .number()
          .required("Ce champ est obligatoire")
          .typeError("Ce champ est obligatoire"),
      otherwise: () =>
        yup
          .number()
          .nullable(true)
          .optional()
          .typeError("Ce champ est obligatoire")
          .transform((_, val) => {
            const result = val == Number(val) ? Number(val) : null;
            return result;
          }),
    }),
    addressName: yup.number().when("taxiActive", {
      is: (v) => v === "true" || v === true,
      then: () =>
        yup
          .string()
          .required("Ce champ est obligatoire")
          .typeError("Ce champ est obligatoire"),
      otherwise: () =>
        yup
          .string()
          .nullable(true)
          .optional()
          .typeError("Ce champ est obligatoire"),
    }),

    ...(isAdmin
      ? {
          placeId: yup
            .object()
            .required("Ce champ est obligatoire")
            .typeError("Ce champ est obligatoire"),
        }
      : {}),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control: formControl,
    setValue: setFormValue,
    watch: watchFormValue,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      minNumberOfPersons: 1,
      stepOfNumberOfPersons: 1,
      taxiActive: "false",
      authConfirmBookings: "true",
      isVisible: "true",
      nightPriceHoursRange: { from: "", to: "" },
    },
  });

  const selectedPlace = watchFormValue("placeId");
  const {
    fields: variantItemsFields,
    append: appendVariantItemField,
    remove: removeVariantItemField,
    update: updateVariantItemField,
    move: moveVariantItemField,
  } = useFieldArray({
    control: formControl,
    name: "variants",
  });
  const taxiActiveValue = watchFormValue("taxiActive");

  useEffect(() => {
    if (mode === FormMode.UPDATE && params?.id) {
      const url =
        isAdmin === true
          ? `specials/all/${params.id}`
          : `specials/ours/${params.id}`;
      const formFields = Object.keys(schema.fields);
      apiService.MakeGetRequest(url, token).then((response) => {
        setOfferAvailability(response?.openingHours);
        setDescription(response?.text);
        setFormValue("placeId", response.place);
        setFormValue("picture", response.image);
        setFormValue("carouselImage", response.carouselPicture);
        setFormValue("weekDays", response.weekDays);
        const paymentOptions = response.paymentOptions ?? [];
        if (paymentOptions?.includes("in_place")) {
          setFormValue("paymentMethodsInPlace", true);
        }
        if (paymentOptions?.includes("credit_card")) {
          setFormValue("paymentMethodsCreditCard", true);
        }
        if (paymentOptions?.includes("wafacash")) {
          setFormValue("paymentMethodsWafacash", true);
        }
        if (paymentOptions?.includes("stripe")) {
          setFormValue("paymentMethodsStripe", true);
        }
        if (paymentOptions?.includes("user_balance")) {
          setFormValue("paymentMethodsBalance", true);
        }
        setImages({ carousel: response.carouselPicture, main: response.image });
        if (response?.offerHoursRange) {
          setFormValue("from", response?.offerHoursRange?.from);
          setFormValue("to", response?.offerHoursRange?.to);
        }
        if (response?.nightPriceHoursRange) {
          setFormValue("nightPriceHoursRange", {
            from: response?.nightPriceHoursRange?.from ?? "",
            to: response?.nightPriceHoursRange?.to ?? "",
          });
        }

        setFormValue("points", response?.points);

        if (response?.variants) {
          setFormValue(
            "variants",
            response?.variants?.map((item) => ({
              ...item,
              prix: item?.price,
              prixEnEuro: item?.priceInEuro,
              nightPrice: item?.nightPrice ?? "",
              nightPriceInEuro: item?.nightPriceInEuro ?? "",
              maxNumberOfPersons: item?.maxNumberOfPersons ?? "",
              itemId: item.id,
              isSaved: true,
              isDeleted: false,
              disabled: item?.disabled,
              isVisible: item?.isVisible,
            })),
          );
        }
        Object.entries(response).forEach((entry) => {
          if (formFields.indexOf(entry[0]) !== -1) {
            // setFormValue(entry[0], entry[1]);
            if (entry[0] === "date") {
              setFormValue(entry[0], toDateInputValue(entry[1]));
            } else {
              setFormValue(entry[0], entry[1]);
            }
          }
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.id]);

  // @desc create new user
  const createNewOfferMutation = useMutation(async (data: SpecialOffers) => {
    return await apiService.MakePostRequest("specials", data, token, true);
  });

  const updateSpecialOfferMutation = useMutation(async (data) => {
    return await apiService.MakePutRequest(
      `specials/${params.id}?placeId=${selectedPlaceId}`,
      data,
      token,
      true,
    );
  });

  const deleteVariantMutation = useMutation(async (variantId) => {
    return await apiService.MakeDeleteRequest(
      `specials/${params.id}/variant/${variantId}?placeId=${selectedPlaceId}`,
      token,
    );
  });

  const createVariantMutation = useMutation(async (data) => {
    return await apiService.MakePostRequest(
      `specials/${params.id}/variant?placeId=${selectedPlaceId}`,
      data,
      token,
    );
  });

  const updateVariantMutation = useMutation(async ({ variantId, data }) => {
    return await apiService.MakePutRequest(
      `specials/${params.id}/variant/${variantId}?placeId=${selectedPlaceId}`,
      data,
      token,
    );
  });

  const createSpecialOffer = async (data) => {
    try {
      setFormLoading(true);
      if (data.weekDays?.length) {
        data.weekDays = JSON.stringify(data.weekDays);
      }

      await createNewOfferMutation.mutateAsync(data);
      toastSuccess(general.fr.message.offerCreated);
      navigate(-1);
    } catch (error) {
      setFormLoading(false);
      toastError(general.fr.message.operationFailed);
    }
  };

  const updateSpecialOffer = async (data) => {
    try {
      setFormLoading(true);
      // console.log("data to update", data);
      if (data.weekDays?.length) {
        data.weekDays = JSON.stringify(data.weekDays);
      }
      const variants = data.variants ?? [];
      delete data.variants;
      const updatedSpecial = updateSpecialOfferMutation.mutateAsync(data);
      const variantsToDelete = variants.filter(
        (item) => item.isDeleted === true && item.isSaved === true,
      );
      const variantsToUpdate = variants.filter(
        (item) => item.isSaved === true && item.isDeleted === false,
      );
      const variantsToCreate = variants.filter(
        (item) => item.isSaved === false,
      );
      const deleteVariants = variantsToDelete.map(
        async (item) => await deleteVariantMutation.mutateAsync(item.itemId),
      );
      const updateVariants = variantsToUpdate.map(
        async (item) =>
          await updateVariantMutation.mutateAsync({
            variantId: item.id,
            data: item,
          }),
      );
      const createVariants = variantsToCreate.map(
        async (item) => await createVariantMutation.mutateAsync(item),
      );
      await Promise.all([
        ...deleteVariants,
        ...updateVariants,
        ...createVariants,
        updatedSpecial,
      ]);
      // await updateSpecialOfferMutation.mutateAsync(data);
      toastSuccess(general.fr.message.offerUpdated);
      navigate(-1);
    } catch (error) {
      console.log(error);
      setFormLoading(false);
      toastError(general.fr.message.operationFailed);
    }
  };

  useEffect(() => {
    if (!isAdmin && selectedPlaceId) {
      setFormValue("placeId", selectedPlaceId);
    }
  }, [isAdmin, selectedPlaceId, setFormValue]);

  const onSubmit = async (dataArg) => {
    const data = { ...dataArg };
    const placeId = selectedPlaceId ?? data.placeId?.id;
    console.log("data to submit", data);
    try {
      if (!offerAvailability) {
        toastError("Veuillez configurer la disponibilité de l'offre");
        return;
      }
      data.type = OFFER_TYPES.SPECIAL;
      const imageFile = verifyFileList(data.picture);
      data.picture = imageFile;
      const carouselImageFile = verifyFileList(data.carouselImage);
      data.carouselImage = carouselImageFile;
      data.placeId = isAdmin ? data.placeId.id : placeId;

      if (!isAdmin) {
        delete data.partnerCommission;
      }

      if (data?.from && data?.to) {
        data.offerHoursRange = JSON.stringify({
          from: data.from,
          to: data.to,
        });
      }
      if (data?.nightPriceHoursRange?.from && data?.nightPriceHoursRange?.to) {
        data.nightPriceHoursRange = {
          from: data.nightPriceHoursRange.from,
          to: data.nightPriceHoursRange.to,
        };
      } else {
        data.nightPriceHoursRange = null;
      }
      if (data?.variants?.length > 0) {
        data.variants = data.variants.map(
          (
            {
              prix,
              prixEnEuro,
              nightPrice,
              nightPriceInEuro,
              description,
              maxNumberOfPersons,
              minNumberOfPersons,
              stepOfNumberOfPersons,
              disabled,
              isVisible,
              ...rest
            },
            index,
          ) => ({
            ...rest,
            price: +prix,
            priceInEuro: +prixEnEuro,
            nightPrice: nightPrice ? +nightPrice : "null",
            nightPriceInEuro: nightPriceInEuro ? +nightPriceInEuro : "null",
            description,
            minNumberOfPersons: +minNumberOfPersons,
            stepOfNumberOfPersons: +stepOfNumberOfPersons,
            maxNumberOfPersons:
              maxNumberOfPersons === "" ? "null" : +maxNumberOfPersons,
            order: index,
            disabled: disabled,
            isVisible: isVisible,
          }),
        );
        // delete data?.variants;
      }

      data.openingHours = offerAvailability;

      if (data?.reductionPercent === null) {
        data.reductionPercent = "";
      }
      if (data?.price === null) {
        data.price = "";
      }

      if (data?.priceInEuro === null) {
        data.priceInEuro = "";
      }
      if (data?.variants?.length > 0) {
        delete data.nightPrice;
        delete data.nightPriceInEuro;
      } else {
        data.nightPrice = data.nightPrice ? +data.nightPrice : "null";
        data.nightPriceInEuro = data.nightPriceInEuro
          ? +data.nightPriceInEuro
          : "null";
      }
      if (!data?.numberOfPersons) {
        data.numberOfPersons = "null";
      }
      if (!data?.date) {
        data.date = "null";
      }
      if (!data?.duration) {
        data.duration = "null";
      }

      const paymentOptions = [];
      if (data.paymentMethodsInPlace) {
        paymentOptions.push("in_place");
      }
      if (data.paymentMethodsCreditCard) {
        paymentOptions.push("credit_card");
      }
      if (data.paymentMethodsWafacash) {
        paymentOptions.push("wafacash");
      }
      if (data.paymentMethodsStripe) {
        paymentOptions.push("stripe");
      }

      if (data.paymentMethodsBalance) {
        paymentOptions.push("user_balance");
      }

      const uiErrors = [];
      // validation
      if (
        paymentOptions.includes("wafacash") &&
        !isPositive(data.price) &&
        data.variants?.length <= 0
      ) {
        uiErrors.push(
          "L'offre accepte payment Wafacash mais le prix n'est pas renseigné",
        );
      }
      if (
        paymentOptions.includes("credit_card") &&
        !isPositive(data.price) &&
        data.variants?.length <= 0
      ) {
        uiErrors.push(
          "L'offre accepte payment par carte bancaire mais le prix n'est pas renseigné",
        );
      }
      if (
        paymentOptions.includes("stripe") &&
        !isPositive(data.priceInEuro) &&
        data.variants?.length <= 0
      ) {
        uiErrors.push(
          "L'offre accepte payment Stripe mais le prix en euro n'est pas renseigné",
        );
      }
      if (
        paymentOptions.includes("wafacash") &&
        data.variants.some((variant) => !isPositive(variant.price)) &&
        data.variants?.length > 0
      ) {
        uiErrors.push(
          "L'offre accepte payment Wafacash mais le prix n'est pas renseigné pour tous les variant",
        );
      }
      if (
        paymentOptions.includes("credit_card") &&
        data.variants.some((variant) => !isPositive(variant.price)) &&
        data.variants?.length > 0
      ) {
        uiErrors.push(
          "L'offre accepte payment par carte bancaire mais le prix n'est pas renseigné pour tous les variant",
        );
      }
      if (
        paymentOptions.includes("stripe") &&
        data.variants.some((variant) => !isPositive(variant.priceInEuro)) &&
        data.variants?.length > 0
      ) {
        uiErrors.push(
          "L'offre accepte payment Stripe mais le prix n'est pas renseigné pour tous les variant",
        );
      }
      if (
        paymentOptions.includes("user_balance") &&
        data.variants.some((variant) => !isPositive(variant.price)) &&
        data.variants?.length > 0
      ) {
        uiErrors.push(
          "L'offre accepte payment User Balance mais le prix n'est pas renseigné pour tous les variant",
        );
      }

      if (
        paymentOptions.includes("user_balance") &&
        !isPositive(data.price) &&
        data.variants?.length <= 0
      ) {
        uiErrors.push(
          "L'offre accepte payment User Balance mais le prix n'est pas renseigné",
        );
      }

      if (uiErrors.length > 0) {
        toastError(uiErrors.join("\n"));
        return;
      }

      data.paymentOptions = JSON.stringify(paymentOptions);

      if (mode === FormMode.UPDATE) {
        updateSpecialOffer(data);
      } else {
        createSpecialOffer(data);
      }
    } catch (error) {
      setFormLoading(false);
      toastError(general.fr.message.operationFailed);
    }
  };

  const deleteVariantItem = async (item, index) => {
    if (item.isSaved === true) {
      updateVariantItemField(index, { ...item, isDeleted: true });
    } else {
      removeVariantItemField(index);
    }
  };

  // console.log("formstate.errors", errors);

  const isCreate = mode !== FormMode.UPDATE;
  const taxiOn = taxiActiveValue === "true" || taxiActiveValue === true;
  const hasVariants = variantItemsFields.length > 0;
  const err = (i: number, key: string) => errors?.variants?.[i]?.[key]?.message;

  return (
    <div className="vz-form px-2">
      {/* Header */}
      <div
        style={{ ...cardStyle, padding: "16px 20px" }}
        className="d-flex justify-content-between align-items-center mb-3"
      >
        <div>
          <h4 className="fs-4 fw-bold mb-0">
            {isCreate ? "Créer une offre" : "Mettre à jour l'offre"}
          </h4>
          <div className="text-muted" style={{ fontSize: 13 }}>
            Les champs marqués d'une * sont obligatoires
          </div>
        </div>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="btn btn-outline-secondary rounded-pill px-3"
        >
          ← Retour
        </button>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        {/* General */}
        <FormSection title="Informations générales">
          <Field
            label="Titre de l'offre"
            htmlFor="title"
            required
            error={errors.title?.message}
          >
            <CFormInput
              id="title"
              placeholder="Titre de l'offre"
              {...register("title")}
            />
          </Field>

          {isAdmin && (
            <Field
              label={
                selectedPlace?.isVisible === false
                  ? "Établissement (cet établissement est invisible)"
                  : "Établissement"
              }
              htmlFor="placeId"
              required
              error={errors.placeId?.message}
            >
              <Controller
                name="placeId"
                control={formControl}
                render={({ field }) => (
                  <InfiniteScrollSelect
                    id="placeId"
                    isClearable={false}
                    getOptionLabel={(o) => o?.name}
                    getOptionValue={(o) => o.id}
                    isOptionSelected={(o, selected) =>
                      o?.id === selected?.[0]?.id
                    }
                    url={{ path: "places" }}
                    {...field}
                  />
                )}
              />
            </Field>
          )}

          {isUserMultiPlaceAdmin && (
            <Field
              label="Offre fournie par"
              htmlFor="offerProvider"
              error={errors.offerProvider?.message}
            >
              <CFormInput
                id="offerProvider"
                placeholder="Fournisseur"
                {...register("offerProvider")}
              />
            </Field>
          )}

          <Field
            label="Image de l'offre"
            htmlFor="picture"
            error={errors.picture?.message}
          >
            <FileUploader
              id="picture"
              name="picture"
              accept="image/png,image/jpeg,image/jpg"
              {...register("picture")}
              file={images?.main}
            />
          </Field>

          <Field
            label="Image du carrousel"
            htmlFor="carouselImage"
            required
            error={errors.carouselImage?.message}
          >
            <FileUploader
              id="carouselImage"
              name="carouselImage"
              accept="image/png,image/jpeg,image/jpg"
              {...register("carouselImage")}
              file={images?.carousel}
              required={isCreate}
            />
          </Field>

          <div className="col-12">
            <label
              className="d-block mb-1 fw-semibold"
              style={{ fontSize: 13 }}
            >
              Description de l'offre
            </label>
            <RichTextEditor
              defaultValue={description}
              onChange={(data) => {
                setDescription(data);
                setFormValue("text", data);
              }}
            />
            {errors.text?.message && (
              <div style={{ color: "#dc3545", fontSize: 12 }} className="mt-1">
                {errors.text.message}
              </div>
            )}
          </div>
        </FormSection>

        {/* Pricing */}
        <FormSection
          title="Tarification"
          description={
            hasVariants
              ? "Les prix sont définis par variant (voir plus bas)"
              : undefined
          }
        >
          <Field
            label="Prix (DH)"
            htmlFor="price"
            error={errors.price?.message}
          >
            <CFormInput
              id="price"
              type="number"
              step="0.01"
              placeholder="Prix"
              {...register("price")}
            />
          </Field>
          <Field
            label="Prix en euro (€)"
            htmlFor="priceInEuro"
            error={errors.priceInEuro?.message}
          >
            <CFormInput
              id="priceInEuro"
              type="number"
              step="0.01"
              placeholder="Prix"
              {...register("priceInEuro")}
            />
          </Field>

          {!hasVariants && (
            <>
              <Field
                label="Prix du soir (DH)"
                htmlFor="nightPrice"
                error={errors.nightPrice?.message}
              >
                <CFormInput
                  id="nightPrice"
                  type="number"
                  step="0.01"
                  placeholder="Prix du soir"
                  {...register("nightPrice")}
                />
              </Field>
              <Field
                label="Prix du soir en euro (€)"
                htmlFor="nightPriceInEuro"
                error={errors.nightPriceInEuro?.message}
              >
                <CFormInput
                  id="nightPriceInEuro"
                  type="number"
                  step="0.01"
                  placeholder="Prix du soir"
                  {...register("nightPriceInEuro")}
                />
              </Field>
            </>
          )}

          <Field label="Période de prix du soir" col="col-12">
            <div className="row g-3">
              <div className="col-md-6">
                <Controller
                  name="nightPriceHoursRange.from"
                  control={formControl}
                  render={({ field }) => (
                    <TimeSelectInput
                      label="Heure de début"
                      selectedTime={field.value ?? ""}
                      onChange={field.onChange}
                    />
                  )}
                />
              </div>
              <div className="col-md-6">
                <Controller
                  name="nightPriceHoursRange.to"
                  control={formControl}
                  render={({ field }) => (
                    <TimeSelectInput
                      label="Heure de fin"
                      selectedTime={field.value ?? ""}
                      onChange={field.onChange}
                    />
                  )}
                />
              </div>
            </div>
          </Field>

          <Field
            label="Remise (%)"
            htmlFor="reductionPercent"
            error={errors.reductionPercent?.message}
          >
            <CFormInput
              id="reductionPercent"
              type="number"
              placeholder="Remise"
              {...register("reductionPercent")}
            />
          </Field>

          {isAdmin && (
            <>
              <Field
                label="Commission partenaire (%)"
                htmlFor="partnerCommission"
                error={errors.partnerCommission?.message}
              >
                <CFormInput
                  id="partnerCommission"
                  type="number"
                  min={0}
                  max={100}
                  step="0.01"
                  placeholder="Ex : 10"
                  {...register("partnerCommission")}
                />
              </Field>
              <Field
                label="Points"
                htmlFor="points"
                error={errors.points?.message}
              >
                <CFormInput
                  id="points"
                  type="number"
                  step="1"
                  min="0"
                  {...register("points")}
                />
              </Field>
            </>
          )}
        </FormSection>

        {/* Capacity & dates */}
        <FormSection title="Capacité et dates">
          <Field
            label="Nombre de personnes"
            htmlFor="numberOfPersons"
            error={errors.numberOfPersons?.message}
          >
            <CFormInput
              id="numberOfPersons"
              type="number"
              {...register("numberOfPersons")}
            />
          </Field>
          <Field label="Date" htmlFor="date" error={errors.date?.message}>
            <CFormInput id="date" type="date" {...register("date")} />
          </Field>
          <Field
            label="Durée de l'offre (en jours)"
            htmlFor="duration"
            error={errors.duration?.message}
          >
            <CFormInput id="duration" type="number" {...register("duration")} />
          </Field>
          <Field
            label="Nombre minimum de personnes"
            htmlFor="minNumberOfPersons"
            required
            error={errors.minNumberOfPersons?.message}
          >
            <CFormInput
              id="minNumberOfPersons"
              type="number"
              {...register("minNumberOfPersons")}
            />
          </Field>
          <Field
            label="Étape entre le nombre de personnes"
            htmlFor="stepOfNumberOfPersons"
            required
            error={errors.stepOfNumberOfPersons?.message}
          >
            <CFormInput
              id="stepOfNumberOfPersons"
              type="number"
              {...register("stepOfNumberOfPersons")}
            />
          </Field>
        </FormSection>

        {/* Availability & payment */}
        <FormSection title="Disponibilité et paiement">
          <Field label="Disponibilité de l'offre" required>
            <div className="d-flex align-items-center gap-2">
              <button
                type="button"
                className="btn btn-outline-primary rounded-pill px-3"
                onClick={() => setShowOpeningHours(true)}
              >
                Configurer la disponibilité
              </button>
              <span
                className="rounded-pill px-2"
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  height: 22,
                  display: "inline-flex",
                  alignItems: "center",
                  color: offerAvailability ? "#198754" : "#dc3545",
                  backgroundColor: offerAvailability
                    ? "rgba(25,135,84,0.12)"
                    : "rgba(220,53,69,0.12)",
                }}
              >
                {offerAvailability ? "✓ Configurée" : "Non configurée"}
              </span>
            </div>
          </Field>

          <Field label="Méthodes de paiement">
            <div className="d-flex flex-wrap gap-4 pt-1">
              <CFormCheck
                id="paymentMethodsCreditCard"
                label="Carte bancaire"
                {...register("paymentMethodsCreditCard")}
              />
              <CFormCheck
                id="paymentMethodsWafacash"
                label="Wafacash"
                {...register("paymentMethodsWafacash")}
              />
              <CFormCheck
                id="paymentMethodsInPlace"
                label="Sur place"
                {...register("paymentMethodsInPlace")}
              />
              <CFormCheck
                id="paymentMethodsStripe"
                label="Stripe"
                {...register("paymentMethodsStripe")}
              />
              <CFormCheck
                id="paymentMethodsBalance"
                label="Solde utilisateur"
                {...register("paymentMethodsBalance")}
              />
            </div>
          </Field>

          <Field
            label="Confirmer automatiquement les réservations"
            htmlFor="authConfirmBookings"
            required
            error={errors.authConfirmBookings?.message}
          >
            <CFormSelect
              id="authConfirmBookings"
              {...register("authConfirmBookings")}
            >
              <option value="true">Oui</option>
              <option value="false">Non</option>
            </CFormSelect>
          </Field>
          <Field
            label="Visible"
            htmlFor="isVisible"
            required
            error={errors.isVisible?.message}
          >
            <CFormSelect id="isVisible" {...register("isVisible")}>
              <option value="true">Oui</option>
              <option value="false">Non</option>
            </CFormSelect>
          </Field>
        </FormSection>

        {/* Taxi (admin) */}
        {isAdmin && (
          <FormSection title="Configuration taxi">
            <Field
              label="Taxi actif"
              htmlFor="taxiActive"
              required
              error={errors.taxiActive?.message}
            >
              <CFormSelect id="taxiActive" {...register("taxiActive")}>
                <option value="false">Non</option>
                <option value="true">Oui</option>
              </CFormSelect>
            </Field>
            <Field
              label="Adresse taxi"
              htmlFor="addressName"
              required={taxiOn}
              error={errors.addressName?.message}
            >
              <input
                id="addressName"
                className="form-control"
                placeholder="Adresse"
                {...register("addressName")}
              />
            </Field>
            <Field
              label="Latitude"
              htmlFor="latitude"
              required={taxiOn}
              error={errors.latitude?.message}
            >
              <input
                id="latitude"
                type="number"
                step="0.0000000001"
                className="form-control"
                {...register("latitude")}
              />
            </Field>
            <Field
              label="Longitude"
              htmlFor="longitude"
              required={taxiOn}
              error={errors.longitude?.message}
            >
              <input
                id="longitude"
                type="number"
                step="0.0000000001"
                className="form-control"
                {...register("longitude")}
              />
            </Field>
          </FormSection>
        )}

        {/* Variants */}
        <section style={cardStyle} className="mb-3">
          <div
            className="d-flex justify-content-between align-items-center mb-3 pb-2"
            style={{ borderBottom: "1px solid #f0f0f0" }}
          >
            <div>
              <h6 className="fw-bold mb-0" style={{ fontSize: 15 }}>
                Variants {hasVariants && `(${variantItemsFields.length})`}
              </h6>
              <div className="text-muted" style={{ fontSize: 12 }}>
                Glissez les cartes par la poignée ⋮⋮ pour changer l'ordre
              </div>
            </div>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary rounded-pill px-3"
              onClick={() =>
                appendVariantItemField({
                  description: "",
                  prix: 0,
                  nightPrice: "",
                  nightPriceInEuro: "",
                  minNumberOfPersons: 1,
                  stepOfNumberOfPersons: 1,
                  isSaved: false,
                  isDeleted: false,
                  disabled: false,
                  isVisible: true,
                })
              }
            >
              + Ajouter un variant
            </button>
          </div>

          {!hasVariants && (
            <div
              className="text-center text-muted py-3"
              style={{
                border: "1px dashed #ddd",
                borderRadius: 12,
                fontSize: 13,
              }}
            >
              Aucun variant
            </div>
          )}

          <ReactSortable
            list={[]}
            setList={() => {}}
            handle=".vz-drag"
            className="d-flex flex-column gap-3"
            onEnd={(e) => moveVariantItemField(e.oldIndex, e.newIndex)}
          >
            {variantItemsFields.map((variantItem, index) => {
              const deleted = variantItem?.isDeleted;
              return (
                <div
                  key={variantItem?.id}
                  className="d-flex gap-3 p-3"
                  style={{
                    border: "1px solid #eee",
                    borderRadius: 12,
                    backgroundColor: "#fcfcfc",
                  }}
                >
                  <span
                    className="vz-drag text-muted d-flex align-items-start"
                    style={{ cursor: "grab", userSelect: "none", fontSize: 18 }}
                    title="Déplacer"
                  >
                    ⋮⋮
                  </span>

                  <div
                    className="flex-grow-1"
                    style={{
                      opacity: deleted ? 0.4 : 1,
                      pointerEvents: deleted ? "none" : "all",
                    }}
                  >
                    <div className="row g-3">
                      <Field
                        col="col-md-6 col-lg-4"
                        label="Description"
                        htmlFor={`variant_description_${index}`}
                        error={err(index, "description")}
                      >
                        <CFormInput
                          id={`variant_description_${index}`}
                          placeholder="Description"
                          {...register(`variants.${index}.description`)}
                        />
                      </Field>
                      <Field
                        col="col-md-6 col-lg-4"
                        label="Prix (DH)"
                        htmlFor={`variant_prix_${index}`}
                        error={err(index, "prix")}
                      >
                        <CFormInput
                          id={`variant_prix_${index}`}
                          type="number"
                          step="0.01"
                          {...register(`variants.${index}.prix`)}
                        />
                      </Field>
                      <Field
                        col="col-md-6 col-lg-4"
                        label="Prix en euro (€)"
                        htmlFor={`variant_prixEnEuro_${index}`}
                        error={err(index, "prixEnEuro")}
                      >
                        <CFormInput
                          id={`variant_prixEnEuro_${index}`}
                          type="number"
                          step="0.01"
                          {...register(`variants.${index}.prixEnEuro`)}
                        />
                      </Field>
                      <Field
                        col="col-md-6 col-lg-4"
                        label="Prix du soir (DH)"
                        htmlFor={`variant_nightPrice_${index}`}
                      >
                        <CFormInput
                          id={`variant_nightPrice_${index}`}
                          type="number"
                          step="0.01"
                          {...register(`variants.${index}.nightPrice`)}
                        />
                      </Field>
                      <Field
                        col="col-md-6 col-lg-4"
                        label="Prix du soir en euro (€)"
                        htmlFor={`variant_nightPriceInEuro_${index}`}
                      >
                        <CFormInput
                          id={`variant_nightPriceInEuro_${index}`}
                          type="number"
                          step="0.01"
                          {...register(`variants.${index}.nightPriceInEuro`)}
                        />
                      </Field>
                      <Field
                        col="col-md-6 col-lg-4"
                        label="Minimum de personnes"
                        htmlFor={`variant_min_${index}`}
                        error={err(index, "minNumberOfPersons")}
                      >
                        <CFormInput
                          id={`variant_min_${index}`}
                          {...register(`variants.${index}.minNumberOfPersons`)}
                        />
                      </Field>
                      <Field
                        col="col-md-6 col-lg-4"
                        label="Étape entre personnes"
                        htmlFor={`variant_step_${index}`}
                        error={err(index, "stepOfNumberOfPersons")}
                      >
                        <CFormInput
                          id={`variant_step_${index}`}
                          {...register(
                            `variants.${index}.stepOfNumberOfPersons`,
                          )}
                        />
                      </Field>
                      <Field
                        col="col-md-6 col-lg-4"
                        label="Maximum de personnes"
                        htmlFor={`variant_max_${index}`}
                        error={err(index, "maxNumberOfPersons")}
                      >
                        <CFormInput
                          id={`variant_max_${index}`}
                          {...register(`variants.${index}.maxNumberOfPersons`)}
                        />
                      </Field>
                      <Field
                        col="col-md-6 col-lg-2"
                        label="Désactivé"
                        htmlFor={`variant_disabled_${index}`}
                      >
                        <CFormSelect
                          id={`variant_disabled_${index}`}
                          {...register(`variants.${index}.disabled`)}
                        >
                          <option value="false">Non</option>
                          <option value="true">Oui</option>
                        </CFormSelect>
                      </Field>
                      <Field
                        col="col-md-6 col-lg-2"
                        label="Visible"
                        htmlFor={`variant_visible_${index}`}
                      >
                        <CFormSelect
                          id={`variant_visible_${index}`}
                          {...register(`variants.${index}.isVisible`)}
                        >
                          <option value="true">Oui</option>
                          <option value="false">Non</option>
                        </CFormSelect>
                      </Field>
                    </div>
                  </div>

                  <div className="d-flex flex-column gap-2">
                    {deleted ? (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary rounded-pill px-3"
                        onClick={() =>
                          updateVariantItemField(index, {
                            ...variantItem,
                            isDeleted: false,
                          })
                        }
                        title="Annuler la suppression"
                      >
                        <UndoIcon />
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger rounded-pill px-3"
                        onClick={() => deleteVariantItem(variantItem, index)}
                      >
                        Supprimer
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </ReactSortable>
        </section>

        {/* Sticky actions */}
        <div
          className="d-flex justify-content-end gap-2 py-3 px-3 mt-3"
          style={{
            position: "sticky",
            bottom: 0,
            zIndex: 5,
            backgroundColor: "#fff",
            borderRadius: 16,
            boxShadow: "0 -4px 16px rgba(0,0,0,0.06)",
          }}
        >
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="btn btn-outline-secondary rounded-pill px-4"
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={formLoading}
            className="btn btn-success text-white rounded-pill px-4"
          >
            {formLoading ? <CSpinner size="sm" /> : "Enregistrer"}
          </button>
        </div>
      </form>

      <OpeningHoursModal
        initialValues={offerAvailability}
        visible={showOpeningHours}
        onClose={() => setShowOpeningHours(false)}
        onSubmit={(data) => {
          setOfferAvailability(data);
          setShowOpeningHours(false);
        }}
      />
    </div>
  );
}
